/**
 * Response-Envelope fuer alle /api/v1/-Endpunkte (ADR 0001).
 * Single Source of Truth fuer API, SDK und Tests.
 */
import { z } from 'zod';
import { ERROR_CODES } from './errors.js';
export const apiErrorSchema = z.object({
    code: z.enum(ERROR_CODES),
    message: z.string(),
    /** Correlation-ID des Requests — fuer Support-Rueckfragen ("Ref: …"). */
    request_id: z.string().optional(),
});
/** `{ success: true, data, error: null }` mit typisiertem `data`. */
export function successEnvelopeSchema(data) {
    return z.object({
        success: z.literal(true),
        data,
        error: z.null(),
    });
}
export const errorEnvelopeSchema = z.object({
    success: z.literal(false),
    data: z.null(),
    error: apiErrorSchema,
});
/** Envelope-Union — das, was ein Client tatsaechlich vom Draht liest. */
export function envelopeSchema(data) {
    return z.union([successEnvelopeSchema(data), errorEnvelopeSchema]);
}
export function success(data) {
    return { success: true, data, error: null };
}
export function failure(error) {
    return { success: false, data: null, error };
}
/** Pagination-Parameter — einheitlich ueberall (`?page=&per_page=`). */
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    per_page: z.coerce.number().int().min(1).max(100).default(20),
});
/** Paginierte Liste — steckt komplett in `data`. */
export function paginatedSchema(item) {
    return z.object({
        items: z.array(item),
        total: z.number().int().min(0),
        page: z.number().int().min(1),
        per_page: z.number().int().min(1),
        pages: z.number().int().min(0),
    });
}
export function paginate(items, total, query) {
    return {
        items,
        total,
        page: query.page,
        per_page: query.per_page,
        pages: Math.ceil(total / query.per_page),
    };
}
//# sourceMappingURL=envelope.js.map